export default __webpack_public_path__ + "static/media/B0003.0410b59d.png";